// extracted by mini-css-extract-plugin
module.exports = {"Page":"src_Page__120tg flex flex-col flex-1 my-8 w-full"};